module.exports = __webpack_public_path__ + "img/questica.a0fdf202.png";